import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'pg-calendar-weekdays, grit-calendar-weekdays',
  exportAs: 'gritCalendarWeekdays',
  templateUrl: './pg-calendar-weekdays.component.html',
  styleUrls: ['./pg-calendar-weekdays.component.scss'],
})
export class PgCalendarWeekdaysComponent implements OnInit {
  @HostBinding('class.calendar-padding')
  _paddingClass = true;
  constructor() {}

  ngOnInit() {}
}
